import { Button, Form, Input, message } from "antd";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import axios from "../../utils/axios";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef } from "react";

export default function ForgotPass({ isVerified }) {
  const [form] = Form.useForm();
  const recaptchaRef = useRef(null);
  const { mutate, isLoading } = useMutation({
    mutationKey: "recover",
    mutationFn: (formData) =>
      axios.post("/client/auth/recover", formData, {
        showErrorMessage: true,
        showSuccessMessage: true,
      }),
    onSettled: () => {
      // 4. Reset reCAPTCHA after every attempt (success or failure)
      recaptchaRef.current?.reset();
    },
  });

  const onFinish = async (values) => {
    // 5. Get the token from the widget
    const token = recaptchaRef.current.getValue();

    if (!token) {
      return message.error("Please complete the reCAPTCHA");
    }

    // 6. Append token to the form data
    mutate({ ...values, captcha: token });
  };

  return (
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item name="type" initialValue="email" hidden>
        <Input />
      </Form.Item>
      <Form.Item name="type_value" rules={[{ required: true, message: "Please enter your email!" }]}>
        <Input key="email" className="login_field" type="email" placeholder="Email address" />
      </Form.Item>
      <div style={{ marginBottom: 20, display: "flex", justifyContent: "center" }}>
        <ReCAPTCHA ref={recaptchaRef} sitekey="6LdaJr0eAAAAALCSKgUTcO3z6fZaYMdWsXUf-F7_" />
      </div>
      <Form.Item>
        <Button className="login_button" htmlType="submit" loading={isLoading} block shape="round">
          Continue
        </Button>
      </Form.Item>
      <div style={{ textAlign: "center", paddingTop: 20 }}>
        <Link className="login_link" to="/login/mobile">
          Login with Mobile Number
        </Link>
      </div>
      <div style={{ textAlign: "center", paddingTop: 20 }}>
        <Link className="login_link" to="/login/email">
          Login with email
        </Link>
      </div>
    </Form>
  );
}
